import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The escalation settings shipped under organisation settings before moving
 * into the Fleet section (CUR-1049). The old address stays reachable for the
 * bookmarks and emails that carry it.
 */
export const Route = createFileRoute('/console/$orgId/configuration/org-settings/fleet-escalations')({
    beforeLoad: ({ params }): never => {
        throw redirect({ to: '/console/$orgId/configuration/fleet/escalations', params, replace: true });
    },
});
